import { eventColors } from './calendar-config';

const taskStatuses = [
  {
    name: 'Creada',
    icon: 'check_circle_outline',
    value: 1,
    selected: false,
    filter: false,
    color: '#a6d5ba',
    selectedColor: '#219653',
    code: 'Creada',
    eventColor: eventColors.create,
    enumValue: 'Create',
    order: 9,
  },
  {
    name: 'Agendada',
    icon: 'assignment',
    value: 2,
    selected: false,
    filter: true,
    color: '#bbebfa',
    selectedColor: '#56CCF2',
    code: 'Agendada',
    eventColor: eventColors.accept,
    enumValue: 'Accept',
    order: 6,
  },
  {
    name: 'Preparada',
    icon: 'calendar_today',
    value: 3,
    selected: false,
    filter: true,
    color: '#abd7f1',
    selectedColor: '#2D9CDB',
    code: 'Preparada',
    eventColor: eventColors.schedule,
    enumValue: 'Schedule',
    order: 8,
  },
  {
    name: 'Ejecutandose',
    icon: 'work',
    value: 4,
    selected: false,
    filter: true,
    color: '#fac799',
    selectedColor: '#F37200',
    code: 'Ejecutandose',
    eventColor: eventColors.start,
    enumValue: 'Start',
    order: 12,
  },
  {
    name: 'Pausada',
    icon: 'pause',
    value: 5,
    selected: false,
    filter: true,
    color: '#ffd599',
    selectedColor: '#FF9500',
    code: 'Pausada',
    eventColor: eventColors.pause,
    enumValue: 'Pause',
    order: 2,
  },
  {
    name: 'Finalizada',
    icon: 'done_all',
    value: 6,
    selected: false,
    filter: true,
    color: '#adbf3a33',
    selectedColor: '#adbf3a',
    code: 'Finalizada',
    eventColor: eventColors.finish,
    enumValue: 'Finish',
    order: 4,
  },
  {
    name: 'Suspendida',
    icon: 'pan_tool',
    value: 7,
    selected: false,
    filter: true,
    color: '#d299ff',
    selectedColor: '#8F00FF',
    code: 'Suspendida',
    eventColor: eventColors.suspend,
    enumValue: 'Suspend',
    order: 10,
  },
  {
    name: 'Reprogramar',
    icon: 'restore',
    value: 8,
    selected: false,
    filter: true,
    color: '#ffe999',
    selectedColor: '#FFC700',
    code: 'Reprogramar',
    eventColor: eventColors.reSchedule,
    enumValue: 'ReSchedule',
    order: 1,
  },
  {
    name: 'Cancelada',
    icon: 'cancel',
    value: 9,
    selected: false,
    filter: true,
    color: '#f9bbad',
    selectedColor: '#EF5533',
    code: 'Cancelada',
    eventColor: eventColors.cancel,
    enumValue: 'Cancel',
    order: 3,
  },
  {
    name: 'En transito',
    icon: 'airport_shuttle',
    value: 10,
    selected: false,
    filter: true,
    color: '#a4e7e3',
    selectedColor: '#1BC4BA',
    code: 'EnTransito',
    eventColor: eventColors.onWay,
    enumValue: 'OnWay',
    order: 5,
  },
  {
    name: 'Rechazada',
    icon: 'assignment_return',
    value: 11,
    selected: false,
    filter: true,
    color: '#ffa4ba',
    selectedColor: '#FF1D53',
    code: 'Rechazada',
    eventColor: eventColors.reject,
    enumValue: 'Reject',
    order: 11,
  },
  {
    name: 'En aceptacion',
    icon: 'hourglass_empty',
    value: 12,
    selected: false,
    filter: true,
    color: '#cac2ff',
    selectedColor: '#7A66FF',
    code: 'EnAceptacion',
    eventColor: eventColors.setContractor,
    enumValue: 'SetContractor',
    order: 7,
  },
  {
    name: 'Cerrada',
    icon: 'hourglass_empty',
    value: 13,
    selected: false,
    filter: true,
    color: '#bfcafb',
    selectedColor: '#3f23fb',
    code: 'Cerrada',
    eventColor: eventColors.close,
    enumValue: 'Close',
    order: 13,
  },
  {
    name: 'Pospuesta',
    icon: 'hourglass_empty',
    value: 14,
    selected: false,
    filter: true,
    color: '#edc1a3',
    selectedColor: '#B3917B',
    code: 'Posponer',
    eventColor: eventColors.postponed,
    enumValue: 'Postponed',
    order: 14,
  },
  {
    name: 'Presupuestada',
    icon: 'hourglass_empty',
    value: 15,
    selected: false,
    filter: true,
    color: '#E788BB',
    selectedColor: '#e788bb66',
    code: 'Presupuestar',
    eventColor: eventColors.Presupuestada,
    enumValue: 'Presupuestada',
    order: 15,
  },
];

export { taskStatuses };
